import React, { useEffect, useState } from 'react';
import { fetchSailingSchedules } from 'src/api/shipmentExecution';
import { SearchedVesselSchedules } from 'src/components/pages/VesselSchedules/VesselSchedules.types';
import withStyles from 'react-jss';
import { useParams } from 'react-router-dom';
import message from 'antd/lib/message';
import Spin from 'antd/lib/spin';
import Radio from 'antd/lib/radio/radio';
import DatePicker from 'antd/lib/date-picker';
import Input from 'antd/lib/input';
import moment from 'moment';
import SESailingScheduleCards from '../../SEActions/SETasks/SESailingScheduleCards';
import { Row, Col, Collapse } from 'antd';

type SailingScheduleField = {
  showInputFields: boolean;
  vesselName?: string | undefined;
  originDepartureDate?: string | null;
};

const styles = (theme) => ({
  selectScheduleStyle: {
    color: '#262626',
    fontSize: '14px',
    fontWeight: 550,
    margin: '0px 0px 20px 0px',
  },
  title: {
    color: '#333333',
    fontSize: '18px',
    lineHeight: '18px',
    fontWeight: 550,
  },
  changeLinkStyle: {
    fontSize: '14px',
    lineHeight: '16px',
    color: '#1890FF',
    cursor: 'pointer',
  },
});

const SailingSchedule = (props) => {
  const params = useParams();
  const { classes, value, field, shipmentExecutionId } = props;

  const [allCarriersMap, setAllCarriersMap] = useState(undefined);
  const [schedules, setSchedules] = useState<SearchedVesselSchedules[]>([]);
  const [allPortsMap, setAllPortsMap] = useState<Ports | undefined>(undefined);
  const [sailingDateSelected, setSailingDateSelected] = useState<boolean>(!!value);
  const [selectedSchedule, setSelectedSchedule] = useState<SearchedVesselSchedules | SailingScheduleField | any>();
  const [isFetchingSailingSchedules, setIsFetchingSailingSchedules] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | undefined>();

  const showInputFields = (selectedSchedule as SailingScheduleField) ?.showInputFields;

  const setData = async () => {
    if (shipmentExecutionId) {
      setIsFetchingSailingSchedules(true);
      // TODO: use useApi
      const response = await fetchSailingSchedules(shipmentExecutionId);
      if (response.isSuccess) {
        setSchedules(response?.data?.schedules);
        setAllCarriersMap(response?.data?.allCarriersMap);
        setAllPortsMap(response?.data?.allPortsMap);
        setErrorMessage(undefined);
      } else {
        setErrorMessage(response.errorMessage);
      }
      setIsFetchingSailingSchedules(false);
    }
  };

  useEffect(() => {
    setData();
  }, [sailingDateSelected]);

  React.useEffect(() => {
    setSailingDateSelected(!!value);
    setSelectedSchedule(value);
  }, [value]);

  useEffect(() => {
    if (field) {
      field.setValue(selectedSchedule);
    }
  }, [selectedSchedule]);
  
  const renderSelectedSchedule = () => {
    if (showInputFields) {
      return;
    }
    return (
      <div style={{ width: 880 }}>
        <SESailingScheduleCards
          searchResult={selectedSchedule}
          allCarriersMap={allCarriersMap}
          allPortsMap={allPortsMap}
          extraContent={{
            isServiceNamePresent: true,
            isCutOffPresent: true,
          }}
        />
      </div>
    );
  }

  const renderSelectSchedule = (customWidth?: string, hideClickOption?: boolean) => {
    if (!schedules.length) {
      return;
    }

    return (
      <div>
      <Radio.Group onChange={(e) => setSelectedSchedule(e.target.value)} value={selectedSchedule}>
        {schedules?.map((item) => {
          return (
            <Radio style={{ display: 'flex' }} value={item}>
              <div style={{ width: customWidth ?? "864px", lineHeight: 4 }}>
                <SESailingScheduleCards
                  searchResult={item}
                  allCarriersMap={allCarriersMap}
                  allPortsMap={allPortsMap}
                  extraContent={{
                    isServiceNamePresent: true,
                    isCutOffPresent: true,
                  }}
                />
              </div>
            </Radio>
          );
        })}
      </Radio.Group>
      {
        hideClickOption ? null : (
          <div onClick={() => { setSchedules([]) }} style={{ color: '#3876EE', textAlign: 'right', cursor: "default", width: "845px" }}>
            <a>Not able to find the required sailing schedule? Enter Details Manually.</a>
          </div>
        )
      }
      </div>
    );
  }

  const renderInputFields = () => {
    const sailingDate = (selectedSchedule as SailingScheduleField)?.originDepartureDate;
    const formattedSailingDate = sailingDate ? moment(sailingDate) : undefined;
    return (
      <Row gutter={40}>
        {!field?.disabled && (
          <Col span='6'>
            <div style={{ fontSize: 14, color: '#000' }}>
              Sailing Date:
            </div>
            <div>
              <DatePicker
                showTime
                allowClear
                disabled={field?.disabled}
                placeholder="Sailing Date"
                value={formattedSailingDate}
                onChange={val => setSelectedSchedule({
                  ...selectedSchedule,
                  showInputFields: true,
                  originDepartureDate: val ? moment(val).format() : '',
                })}
              />
            </div>
          </Col>
        )}
        {!field?.disabled && (
          <Col span='6'>
            <div style={{ fontSize: 14, color: '#000' }}>
              Vessel Name:
            </div>
            <div>
              <Input
                disabled={field?.disabled}
                style={{ width: 196 }}
                placeholder="Vessel Name"
                value={(selectedSchedule as SailingScheduleField)?.vesselName}
                onChange={(e) => setSelectedSchedule({
                  ...selectedSchedule,
                  showInputFields: true,
                  vesselName: e.target.value,
                })}
              />
            </div>
          </Col>
        )}
        </Row>
    );
  }

  if (isFetchingSailingSchedules) {
    return <div style={{ width: '120%', textAlign: 'center' }}><Spin /></div>;
  }


  return (
    <div>
      {!sailingDateSelected ? renderSelectSchedule() : renderSelectedSchedule()}
      {/* {!field?.disabled && sailingDateSelected && !!schedules.length && (
        <div className={classes.changeLinkStyle} onClick={() => {
          if (errorMessage?.length) {
            message.error(errorMessage);
          }
          setSailingDateSelected(false);
        }}>
          You want to change the Sailing Schedule?
        </div>
      )} */}
      { !field?.disabled && sailingDateSelected && schedules?.length ? (
        <Collapse style={{ width: "845px" }}>
          <Collapse.Panel header="Choose Another Sailing Schedule" key="1">
            { renderSelectSchedule("820px", true) }
          </Collapse.Panel>
        </Collapse>
      ) : null }
      {
        !field?.disabled && sailingDateSelected && schedules?.length && !showInputFields ? (
          <div onClick={() => { setSchedules([]) }} style={{ color: '#3876EE', textAlign: 'right', cursor: "default", width: "845px" }}>
            <a>Not able to find the required sailing schedule? Enter Details Manually.</a>
          </div>
        ) : null
      }
      {(!schedules?.length || showInputFields) && renderInputFields()}
      
    </div>
  );
};

export default withStyles(styles)(SailingSchedule);
